<div id="main-content">
    <router-outlet></router-outlet>
</div>
